module.exports = __webpack_public_path__ + "img/img_size_03.9c1fcb04.png";